var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-wrapper",
      class: { "nav-wrapper__border": _vm.showBorder }
    },
    [
      _c(
        "div",
        [
          _c("zcy-nav-cate", { attrs: { "show-cate": _vm.showCate } }),
          _vm._v(" "),
          _c("zcy-nav-main")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55fcd606", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55fcd606","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/index.vue
// module id = uMd3
// module chunks = 1 2 3 4 5 6 7 8 9